<template>
  <v-app>
    <v-main style="min-height: 100vh">
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>

<style>
</style>
